import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import classNames from 'classnames';

import TextTruncate from 'rebook/apps/base/components/TextTruncate';
import BookCardHeader from 'rebook/apps/base/components/BookCardHeader';
import FormattedDateTime from 'rebook/apps/base/components/FormattedDateTime';
import SocialShareMenu from 'rebook/apps/base/components/SocialShareMenu';
import { Citation } from 'rebook/apps/books/models';
import Article from 'rebook/apps/base/components/Article';

import styles from './style.scss';


const BookCitation = ({ citation, theme, isBookHeader, textTitle, noTruncate, extraClassName, isDetailPage }) => {
  const { my_citation: myCitation, text, created_at: createdAt } = citation;
  const theCitation = new Citation(citation);
  const citationText = noTruncate
    ? ReactHtmlParser(text)
    : (
      <TextTruncate textColor="7c7f84" collapseLabel="Свернуть отзыв">
        {ReactHtmlParser(text)}
      </TextTruncate>
    );

  return (
    <div className={classNames(
      extraClassName, styles.container,
      (isBookHeader || isDetailPage) && styles.listContainer
    )}>
      <div className={styles.citationWrapper}>
        {isBookHeader && (
          <React.Fragment>
            {myCitation && (
              <div className={classNames('title-2', styles.userCitationHeader)}>
                {textTitle}
              </div>
            )}
            <div className={styles.bookCard}>
              <BookCardHeader withAuthor theme={theme} book={citation.book} GACategory="BookQuote" />
            </div>
            <div className={styles.borderLineBookHeader} />
          </React.Fragment>
        )}
        {(myCitation && !isBookHeader) && (
          <div className={classNames('title-2', styles.userCitationHeader)}>
            {textTitle}
          </div>
        )}
        <div className={styles.citation}>
          <div className={styles.citationTextWrapper}>
            <div className={styles.citationImage} />
            <i className={styles.citationText}>
              <Article>{citationText}</Article>
            </i>
          </div>
          <Link to={theCitation.getLink()}>
            <div className={styles.date}>
              <div className={styles.separator}>
                <FormattedDateTime timestamp={createdAt} format="D MMMM YYYY" />
              </div>
            </div>
          </Link>
        </div>
      </div>
      {(citation && citation.book) && (
        <div className={styles.shareLinks}>
          <div className={styles.borderLine} />
          <SocialShareMenu url={citation.share_url} utmCampaign="citations" imageUrl={citation.book.default_cover} />
        </div>
      )}
    </div>
  );
};

BookCitation.propTypes = {
  citation: PropTypes.object.isRequired,
  myCitation: PropTypes.bool,
  isAuthor: PropTypes.bool,
  isBookHeader: PropTypes.bool,
  textTitle: PropTypes.string,
  text: PropTypes.string,
  createdAt: PropTypes.number,
  theme: PropTypes.string,
};

export default BookCitation;
